export default __webpack_public_path__ + "static/media/1.2ef63f25.png";